import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted Inter (the weights the CSS uses). Loading it from Google Fonts
// would send each visitor's IP address to Google - a GDPR problem in the EU.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

